import Auth from '@/models/common/auth.js'
import MENU_LIST from "@/common/menu/menu.js";
import { saveTags, getTags, saveUserAuth, saveUserMenu } from '@/common/js/storage';
export default {
  data() {
    return {
      // 导航栏集合
      list: [],
    }
  },
  created() {
  },
  methods: {
    /**
     * @desc 用户拥有的菜单权限（树状）
     */
    initUserMenuAuthTree() {
      Auth.getUserMenuAuthTree().then(res => {
        if (res.success) {
          let arr = this.recombinationData(res.result)
          let keyWordList = this.getKeyWordList(res.result)
          saveUserAuth(keyWordList)
          let arr2 = this.childrenEmptyToNull(res.result)
          saveUserMenu(arr2)
          this.list = arr
          let originalTags = this.delTags(this.list)
          let tags = this.unique(originalTags)
          let tagsCopy = tags.sort((a, b) => { return a.time - b.time })
          saveTags(tagsCopy)
          this.$bus.emit('updateTags')
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /**
     * @desc 重组菜单列表
     */
    recombinationData(list, v = []) {
      let num = 0
      list.map((i, index) => {
        let obj = MENU_LIST[i.keyword]
        // 暂时过滤
        if (obj !== undefined) {
          obj.name = i.name
          if (i.children && i.children.length > 0) {
            obj.children = []
            v.push(obj)
            this.recombinationData(i.children, v[index-num].children)
          } else {
            v.push(obj)
          }
        } else {
          num++
        }
      })
      return v
    },

    /** 
     * @desc 获取用户拥有的keyword集合
    */
    getKeyWordList(list, v = []) {
      list.map(i => {
        if (i.children && i.children.length > 0) {
          v.push(i.keyword)
          this.getKeyWordList(i.children, v)
        } else {
          v.push(i.keyword)
        }
      })
      return v
    },

    /** 
     * @desc 获取menuList(子节点children为空转换null)
    */
    childrenEmptyToNull(list) {
      let arr = []
      list.map((i) => {
        let obj = MENU_LIST[i.keyword]
        // 暂时过滤
        if (obj !== undefined) {
          let newData = {};
          newData.id = i.id;
          newData.keyword = i.keyword;
          newData.name = i.name;
          if (i.children && i.children.length>0) {
            newData.children = this.childrenEmptyToNull(i.children)
          }
          arr.push(newData);
        }
      });

      return arr
    },

    /**
     * @desc 根据权限删除tags
     */
    delTags(list, v = []) {
      let tags = getTags()
      tags.map(i => {
        list.map(j => {
          if (i.authKeyWord === j.keyword || i.authKeyWord === 'default') {
            // 存在权限
            v.push(i)
          }
          if (j.children && j.children.length > 0) {
            this.delTags(j.children, v)
          }
        })
      })
      return v
    },

    /** 
     * @desc 去重(后面替换前面的)
    */
    unique(arr) {
      let res = []
      let map = new Map()
      for (let i of arr) {
        map.set(i.url, i)
      }
      res = [...map.values()]
      return res
    }
  }
}